import 'css-chunksrc/client/scenes/documentCreation/form/folderSelection/folder/logo/styles.scss';export default {
  "logo": "_logo_mu27f_1"
};